// This file handles Dropbox OAuth callback
// It should be called when the page loads to check for OAuth tokens in the URL

export const handleDropboxOAuthCallback = (onSuccess) => {
  // Check if we're returning from Dropbox OAuth
  const { hash } = window.location;

  if (hash && hash.includes('access_token')) {
    try {
      // Parse the hash parameters
      const params = new URLSearchParams(hash.substring(1));
      const accessToken = params.get('access_token');
      const state = params.get('state');

      // Verify state matches
      const storedState = sessionStorage.getItem('dropboxOAuthState');

      if (state === storedState && accessToken) {
        // Fetch user info from Dropbox
        fetch('https://api.dropboxapi.com/2/users/get_current_account', {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
          },
          body: 'null',
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
          })
          .then((userInfo) => {
            const email = userInfo.email || 'Unknown';

            // Clean up
            sessionStorage.removeItem('dropboxOAuthState');

            // Clear the hash from URL
            window.history.replaceState(null, null, window.location.pathname);

            // Call success callback if provided
            if (onSuccess) {
              onSuccess({ accessToken, email });
            }
          })
          .catch((error) => {
            // eslint-disable-next-line no-console
            console.error('Error fetching Dropbox user info:', error);
            sessionStorage.removeItem('dropboxOAuthState');
          });
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error handling Dropbox OAuth callback:', error);
    }
  }
};
